module.exports = __webpack_public_path__ + "assets/img/ENTRANSITOHACIAESPAA.6bd3288d.svg";